import { render, staticRenderFns } from "./receiveTransferBill.vue?vue&type=template&id=b060e298&"
import script from "./receiveTransferBill.vue?vue&type=script&lang=js&"
export * from "./receiveTransferBill.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports